/* Must be compatible with snake_case variant in @performyard/models */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AutoflowResourceLog () {
        return AutoflowResourceLog;
    },
    get AutoflowResourceLogConductorData () {
        return AutoflowResourceLogConductorData;
    },
    get AutoflowResourceLogData () {
        return AutoflowResourceLogData;
    },
    get AutoflowResourceType () {
        return AutoflowResourceType;
    }
});
const _zod = require("zod");
const _autoflows = require("../../autoflows");
const _baseresourcelog = require("../base-resource-log");
const AutoflowResourceType = _zod.z.literal("autoflow");
const AutoflowChangeType = _zod.z.union([
    _zod.z.literal("validate"),
    _zod.z.literal("test"),
    _zod.z.literal("execute")
]);
const AutoflowResourceLogConductorData = _zod.z.object({
    tasks: _autoflows.AutoflowTask.array(),
    valid: _zod.z.boolean(),
    results: _autoflows.AutoflowTaskResponse.array()
});
const AutoflowResourceLogData = _baseresourcelog.BaseResourceLog.shape.data.or(AutoflowResourceLogConductorData).or(_autoflows.AutoflowModel.partial());
const AutoflowResourceLog = _baseresourcelog.BaseResourceLog.extend({
    resourceType: AutoflowResourceType,
    changeType: _baseresourcelog.BaseResourceChangeType.or(AutoflowChangeType),
    data: AutoflowResourceLogData
});
